import useData from "./useData";

const useDimensions = () => {
	const offsetTop = 0;

	const { parentInnerHeight, parentInnerWidth } = useData();
	const innerWidth = window.innerWidth;
	const innerHeight = window.innerHeight;

	const inDesktopOnly = Number(parentInnerWidth) > 600;
	const isLargeWidget = innerWidth > 560;
	// TODO: update canUsePPE condition based on widget_version
	const canUsePPE = parentInnerHeight < 1000;

	const shouldConsiderLargeWidget = (
		conditional = true,
		checkLargeWidget = true
	) => (checkLargeWidget ? isLargeWidget && conditional : conditional);

	// TODO
	// WHAT WAS INNER WIDTH EARLIER HAS NOW BEEN CHANGED TO PARENT INNER WIDTH
	// UPDATE;
	return {
		parentInnerHeight,
		parentInnerWidth,
		inDesktopOnly,
		isLargeWidget,
		shouldConsiderLargeWidget,
		offsetTop,
		innerHeight,
		innerWidth,
		canUsePPE,
	};
};

export default useDimensions;
